<template>
  <div
    v-if="infoList"
    class="main">
    <module-title :module-title="moduleTitle"/>
    <div class="info-list">
      <div v-for="(item, index) in arr" :key="index">
        <div v-if="index < 2" class="info-list-item" :class="{ 'nopadding': index === 0, 'noborderb': index === 1 }">
          <div class="item-left">
            <div class="title">社保卡不激活领不到钱怎么办？</div>
            <div class="time">6小时前发布</div>
            <div class="see">
              <img src="https://cdn.51ljb.cn/ljb_icons_zx_dz.png">
              <span>66</span>
              <img src="https://cdn.51ljb.cn/ljb_icons_zx_ll.png">
              <span>120</span>
            </div>
          </div>
          <div class="item-right">
            <img src="https://cdn.51ljb.cn/ljb_icons_zx_imgurl.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitleNew'
import {mapGetters} from 'vuex'
let namespce = 'Channel'
export default {
  name: 'ListService',
  components: {ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '热门资讯',
        text: '查看更多 >',
        url: 'Information',
      },
      arr: [1,2,3]
    }
  },
  computed: {
    ...mapGetters(namespce, ['getChannelData']),
    infoList () {
      if (this.getChannelData) {
        if (this.getChannelData.activity && Object.keys(this.getChannelData.activity).length > 0) {
          return this.getChannelData.activity
        }
      }
      return null
    }
  },
  methods: {
    goDoc: function (item) {
      this.$utils.checkCanGoRouter(item.url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .main{
    // margin-top: $margin;
    background: #fff;
    padding-bottom: $padding;
  }
  .info-list{
    padding:0 $padding 0 $padding;
    box-sizing:  border-box;
    .info-list-item{
      width: 100%;
      height: 85px;
      display: flex;
      border-bottom: 1px solid #F0F0F0;
      padding-top: $padding;
      .item-left{
        flex: 2;
        padding-right: $padding;
        width: calc(100% - 125px);
        .title{
          width: 100%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
        }
      }
      .item-right{
        flex: 1;
        width: 110px;
        height: 70px;
        >img{
          width: 100%;
          height: 100%;
        }
      }
      .time{
        font-size: 10px;
        font-weight: 400;
        color: #999999;
        margin-top: 5px;
      }
      .see{
        font-size: 9px;
        font-weight: 400;
        color: #999999;
        margin-top: 18px;
        >img{
          width: 9px;
          height: 9px;
          vertical-align: middle;
          margin-top: -2px;
        }
      }
    }
    .nopadding{
      padding-top: 0;
    }
    .noborderb{
      border-bottom: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/list/ListInformation.vue